import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeOpenPriceMaxThreshold: (value: Nullable<number>) => void;
}

export const OpenPriceMaxThreshold: React.FC<IProps> = React.memo(({ changeOpenPriceMaxThreshold }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(
		() => [{ type: 'number', min: 1, message: t('openPriceMaxThresholdIsTooSmall') }],
		[t],
	);

	return (
		<FormInput
			testId="OpenPriceMaxThreshold"
			type="number"
			min={0}
			precision={0}
			name="openPriceMaxThreshold"
			label="openPriceMaxThresholdLabel"
			placeholder="openPriceMaxThresholdPlaceholder"
			onChangeNumber={changeOpenPriceMaxThreshold}
			validationRules={validationRules}
		/>
	);
});
